module.exports = {"width":85,"height":85,"type":"png"}